<div class="page">
  <app-page-header [title]="'admin.categories.title' | translate" [backLabel]="'admin.dashboard.title' | translate" backLink="/admin/dashboard" />

  <div
    class="bg-white dark:bg-slate-800 rounded-lg shadow-lg overflow-hidden border border-slate-200 dark:border-slate-700">
    <div class="overflow-x-auto">
      <table class="min-w-full divide-y divide-slate-200 dark:divide-slate-700">
        <thead class="bg-slate-50 dark:bg-slate-700/50">
          <tr>
            <th scope="col"
              class="px-6 py-3 text-left text-xs font-medium text-slate-600 dark:text-slate-300 uppercase tracking-wider">
              {{ 'admin.categories.name' | translate }}</th>
            <th scope="col"
              class="px-6 py-3 text-center text-xs font-medium text-slate-600 dark:text-slate-300 uppercase tracking-wider">
              {{ 'admin.categories.code' | translate }}</th>
            <th scope="col"
              class="px-6 py-3 text-center text-xs font-medium text-slate-600 dark:text-slate-300 uppercase tracking-wider">
              {{ 'admin.categories.ageRange' | translate }}</th>
          </tr>
        </thead>
        <tbody class="bg-white dark:bg-slate-800 divide-y divide-slate-200 dark:divide-slate-700">
          @for(category of categories; track category.code) {
          <tr class="hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors">
            <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-slate-900 dark:text-slate-100">{{
              category.name }}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm font-mono text-slate-800 dark:text-slate-200 text-center">{{
              category.code }}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-slate-800 dark:text-slate-200 text-center">{{
              category.ageRange }}</td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>